<template>
	<div class="floated-label-input">
		<div class="inner">
			<input
				:id="id"
				v-bind="$attrs"
				v-on="{
					...$listeners,
					input: (e) => $emit('input', e.target.value)
				}"
				:value="value"
				class="input-text floating-input__text"
				:class="[
					customInputClasses,
					{
						'floating-input__text--disabled': isDisabled,
						'floating-input__text--invalid': error
					}
				]"
				@focus="isFocused = true"
				@blur="isFocused = false"
				:disabled="isDisabled"
				:style="style"
			/>
			<label
				:for="id"
				class="floating-input__label"
				:class="{
					'floating-input__label--disabled': isDisabled,
					'floating-input__label--above': value || isFocused
				}"
			>
				{{ label }}
			</label>
		</div>
		<div
			class="validation-container"
			:style="`min-height: ${validationFixedHeight}`"
		>
			<ValidationErrors
				class="floating-input__validation_errors"
				v-show="error"
				:errors="errorMessages"
			/>
		</div>
	</div>
</template>

<script>
import { ValidationErrors } from "./base";
import { input, style } from "./mixins";

/**
 * A standard input with floated label contained within.
 */
export default {
	name: "FloatedLabelInput",

	mixins: [input, style],

	components: {
		ValidationErrors
	},

	data() {
		return {
			isFocused: false
		};
	}
};
</script>

<style lang="scss" scoped>
.floated-label-input {
	width: 100%;

	& > .inner {
		position: relative;
	}
}

.input-text.floating-input__text {
	padding: 36px 16px 9px 16px;
	height: auto;
	margin: 0px;
	display: block;
	width: 100%;

	&--disabled {
		border-color: $color--neutral-8;
		color: $color--neutral-8;
		background-image: none;
		background-color: transparent;
		box-shadow: none;
	}

	&--invalid {
		border-color: $color--red-5 !important;
	}
}

.floating-input__label {
	font-size: 14px;
	left: 16px;
	right: initial;
	top: 50%;
	transform: translateY(-50%);
	pointer-events: none;
	position: absolute;
	transform-origin: left top;
	transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1),
		color 150ms cubic-bezier(0.4, 0, 0.2, 1);
	text-align: left;
	white-space: nowrap;
	cursor: text;
	overflow: hidden;
	will-change: transform;

	&--disabled {
		color: $color--neutral-8;
	}

	&--above {
		transform: translateY(-106%) scale(0.78);
	}
}

.floating-input__validation_errors {
	margin: 8px 0 0 0;
}
</style>
